import { EntityTypes, SectionInterface, Section as SectionUi } from '@email-editor/ui'
import { emailSelectors, useTypedSelector } from '../../store'
import { generateId } from '../../store/email/utils'
import createEntityComponent from '../../utils/createEntityComponent'
import BaseEntity from '../core/BaseEntity/BaseEntity'

type SectionProps = {
  entity: SectionInterface
  position: number
  parentId: string
}

function Section({ entity, position, parentId }: SectionProps) {
  const entities = useTypedSelector(state =>
    emailSelectors.getChildrenEntities(state.email, entity.childIds),
  )

  return (
    <BaseEntity parentId={parentId} entity={entity} position={position}>
      <SectionUi backgroundColor={entity.backgroundColor} padding={entity.padding}>
        {entities.map((child, index) => createEntityComponent(child, index, entity.id))}
      </SectionUi>
    </BaseEntity>
  )
}

export const defaultProps: Partial<SectionInterface> = {
  padding: {
    paddingTop: 10,
    paddingRight: 10,
    paddingBottom: 10,
    paddingLeft: 10,
  },
}

export function createSection(): SectionInterface {
  return {
    id: generateId(),
    childIds: [],
    type: EntityTypes.Section,
    padding: {
      paddingTop: 10,
      paddingRight: 10,
      paddingBottom: 10,
      paddingLeft: 10,
    },
    backgroundColor: 'rgba(255, 255, 255, 1)',
  }
}

export default Section
